'use strict';

var AlgoliaSearch = require('../../AlgoliaSearch.js');
var createAlgoliasearch = require('../createAlgoliasearch.js');

module.exports = createAlgoliasearch(AlgoliaSearch, 'Browser');



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/browser/builds/algoliasearch.js
// module id = 3
// module chunks = 0